<template lang="pug">
  .wrap
    page-title Add new Program
    program-form(v-model='program' @save='onSave')

</template>

<script>
import CrudMixin from "@/shared/mixins/Crud";
import PageTitle from "@/shared/components/layout/PageTitle";
import ProgramForm from "@/itrain/components/shared/programs/ProgramForm";

export default {
  components: { PageTitle, ProgramForm },
  mixins: [CrudMixin],
  data() {
    return {
      program: {
        title: "",
        description: "",
        status: "draft",
        assignees: [],
        programCourses: [],
        notifyOptions: {
          onUserAssigned: {
            sendEmail: false,
            emailMessage:
              "You have been assigned to a new programme, follow the link below to log in to iTrain and review all programmes assigned to you.",
            sendSms: false,
            smsMessage:
              "You have been assigned to a new programme, follow the link below to log in to iTrain and review all programmes assigned to you."
          },
          onCourseAdded: {
            sendEmail: false,
            emailMessage:
              "A new course has been added to one of your programmes. Follow the link below to log in to iTrain and review all courses assigned to you.",
            sendSms: false,
            smsMessage:
              "A new course has been added to one of your programmes. Follow the link below to log in to iTrain and review all courses assigned to you."
          }
        }
      }
    };
  },
  methods: {
    onSave({ valid }) {
      if (!valid) {
        this.$notify({
          title: "Error",
          message: "Please fix the validation errors",
          type: "error"
        });
        return;
      }

      const newProgramData = {
        ...this.program,
        company: this.$store.getters["auth/activeCompany"].id,
        assigneeUserIds: this.program.assignees
          .filter(a => a.user)
          .map(u => u.user.id),
        assigneeAppLicenseGroupIds: this.program.assignees
          .filter(a => a.appLicenseGroup)
          .map(g => g.appLicenseGroup)
      };

      this.wrapApiAction(data => this.$store.dispatch("programs/create", data))(
        {
          data: newProgramData
        }
      ).then(() => {
        this.$router.push({
          name: "itrain:programList"
        });
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
